import { isNil } from "ramda";

import { HospitalConfiguration } from "gql";

export const getNormalRanges = (
  hospitalConfig?: Maybe<
    Pick<
      HospitalConfiguration,
      "wbcRange" | "neutrophilRange" | "haemoglobinRangeMale" | "haemoglobinRangeFemale" | "plateletRange"
    >
  >
): Maybe<NormalRanges> => {
  if (isNil(hospitalConfig)) return null;
  const { haemoglobinRangeFemale, haemoglobinRangeMale, neutrophilRange, plateletRange, wbcRange } = hospitalConfig;
  return { haemoglobinRangeFemale, haemoglobinRangeMale, neutrophilRange, plateletRange, wbcRange };
};

export const isPresentObject = <T, N = unknown>(arg: T | N): arg is T => {
  return arg && typeof arg === "object" && !Array.isArray(arg);
};

export const dateTimeToTimestamp = ({
  timeRecorded,
  dateRecorded,
}: {
  timeRecorded: string;
  dateRecorded: string;
}): string => {
  const recordDate = new Date(dateRecorded);
  const timeSegments = timeRecorded.split(":");
  recordDate.setHours(Number(timeSegments[0]), Number(timeSegments[1]));
  return recordDate.toISOString();
};

export const toNumber = (n?: string | number): number | undefined => {
  if (isNil(n)) return undefined;
  const result = typeof n === "number" ? n : parseFloat(n);
  if (Number.isNaN(result)) return undefined;
  return result;
};

export const startDownload = (url: string) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = url.split("/").pop() ?? "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const EMPTY_RECORD: Record<string, unknown> = {};

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  Object.prototype.toString.call(value) === Object.prototype.toString.call(EMPTY_RECORD);
